"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
const TRUSTPILOT_SCRIPT_URL = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
export const TRUSTPILOT_READY_EVENT = "trustpilot:ready";
export function TrustpilotScript() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script src={TRUSTPILOT_SCRIPT_URL} strategy="afterInteractive" onLoad={_temp} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  return window.dispatchEvent(new Event(TRUSTPILOT_READY_EVENT));
}